/* -------------------------------------------------------------------------- */
/*                               Form-validation                              */
/* -------------------------------------------------------------------------- */

const formValidationInit = () => {
  const forms = document.querySelectorAll('.needs-validation');

  Array.prototype.slice.call(forms).forEach(form => {
    form.addEventListener(
      'submit',
      event => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        form.classList.add('was-validated');
      },
      false
    );
  });
};

export default formValidationInit;
